var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.boundingBoxes),function(localBoundingBox){return _c('div',{key:`${localBoundingBox.top}, ${localBoundingBox.left}`,staticClass:"overlay",style:(_vm.getStyle(localBoundingBox))})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }